export default {
  jpath: ['physical'],
  getEmpty() {
    return {};
  },
};
